import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 门店上级审核、门店云库存
export default [{
  path: "/cloudStock",
  component: function component() {
    return import("../../../views/o2o/cloudStock/index.vue");
  },
  name: "cloudStock",
  meta: {
    title: "门店云库存",
    foot: true
  }
}, {
  path: "/cloudStock_list/:stock_id?",
  component: function component() {
    return import("../../../views/o2o/cloudStock/list.vue");
  },
  name: "cloudStock_list",
  meta: {
    title: "查看明细",
    foot: true
  }
}, {
  path: "/store_applyfor",
  component: function component() {
    return import("../../../views/o2o/cloudStock/apply_for.vue");
  },
  name: "store_applyfor",
  meta: {
    title: "门店审核",
    foot: true
  }
}, {
  path: "/store_applyfor_details/:id?",
  component: function component() {
    return import("../../../views/o2o/cloudStock/details.vue");
  },
  name: "store_applyfor_details",
  meta: {
    title: "门店申请详情",
    foot: true
  }
},
// 门店商品管理
{
  path: "/storeGoods/:storeId?",
  component: function component() {
    return import("../../../views/o2o/store/store_goods.vue");
  },
  name: "storeGoods",
  meta: {
    title: "商品管理",
    foot: true
  }
},
// 发布商品
{
  path: "/storeGoodsRelease/:storeId/:goodsId?",
  component: function component() {
    return import("../../../views/o2o/store/store_goods_release.vue");
  },
  name: "storeGoodsRelease",
  meta: {
    title: "商品发布",
    foot: true
  }
}];